module.exports = __webpack_public_path__ + "img/dpsy-icon-jx.51888700.png";